import router from '../router'
import store from '../store'
import { programmerCalculator, testerCalculator } from '../addons/questionaire_calculator'
import { PROGRAMMER_PROFESSIONS, TESTER_PROFESSIONS } from '@web/constants/questionaire'
import { ROUTE_NAMES } from '@web/router/routes'
import { firebaseDb, firebaseFunctions, firebaseStorage } from '@web/firebase.js'
import { httpsCallable } from 'firebase/functions'
import { doc, getDoc } from 'firebase/firestore'
import { ref, uploadBytes } from 'firebase/storage'

const actions = {
  async initiateGetTechnologies({ commit }) {
    commit('SET_LOADING_STATE', true)

    let technologies = []
    let technologiesPraxis = []

    const docRef = doc(firebaseDb, 'enums', 'za_techs')
    const docSnap = await getDoc(docRef)
    docSnap.data().content.forEach(t => technologies.push(t))

    commit('SET_TECHNOLOGIES', technologies.sort((a, b) => a.name.localeCompare(b.name)))

    technologiesPraxis = technologies.map(e => {
      return {
        name: e.name,
        praxis: 0,
      }
    })

    commit('SET_TECHNOLOGIES_PRAXIS', technologiesPraxis)
    commit('SET_LOADING_STATE', false)
  },
  setFormResultsProfession({ commit }, profession) {
    commit('SET_FORM_RESULTS_PROFESSION', profession)
  },
  setFormResultsData({ commit, state }, professionObject) {
    const { gdpr, ...data } = professionObject

    const profession = state.formResults.profession

    if (PROGRAMMER_PROFESSIONS.includes(profession)) {
      programmerCalculator.computeWage(data)
    } else if (TESTER_PROFESSIONS.includes(profession)) {
      testerCalculator.computeWage(data)
    }

    commit('SET_FORM_RESULTS_DATA', data)
  },
  saveProgrammerToDB({ commit }, programmerObject) {
    commit('SET_LOADING_STATE', true)

    let savedProgrammer = JSON.parse(JSON.stringify(programmerObject))
    savedProgrammer.type = 'questionaire-interest'
    savedProgrammer.personType = 'programmer'
    delete savedProgrammer.technologiesPraxis
    delete savedProgrammer.technologiesKnown

    let firebaseProcessInterest = httpsCallable(firebaseFunctions, 'processQuestionaireInterest')
    firebaseProcessInterest(savedProgrammer)
      .catch(e => {
        console.error(e)
      })
      .finally(() => {
        commit('SET_LOADING_STATE', false)

        router.push({ name: ROUTE_NAMES.THANK_YOU_QUESTIONAIRE })
      })
  },
  saveTesterToDB({ commit }, testerObject) {
    commit('SET_LOADING_STATE', true)

    let savedTester = JSON.parse(JSON.stringify(testerObject))
    savedTester.type = 'questionaire-interest'
    savedTester.personType = 'tester'

    let firebaseProcessInterest = httpsCallable(firebaseFunctions, 'processQuestionaireInterest')
    firebaseProcessInterest(savedTester)
      .catch(e => {
        console.error(e)
      })
      .finally(() => {
        commit('SET_LOADING_STATE', false)
        router.push({ name: ROUTE_NAMES.THANK_YOU_QUESTIONAIRE })
      })
  },
  async saveCVObjectToDB({ commit }, payload) {
    commit('SET_LOADING_STATE', true)

    const fileName = payload.file.name + '_' + makeid(32)
    const fileRef = ref(firebaseStorage, '/CV/' + fileName)
    await uploadBytes(fileRef, payload.file)

    const { file, ...rest } = JSON.parse(JSON.stringify(payload))

    const data = {
      ...rest,
      type: 'questionaire-interest',
      cvFileName: fileName,
    }

    try {
      await httpsCallable(firebaseFunctions, 'processQuestionaireInterest')(data)
    } catch (error) {
      console.error(error)
    } finally {
      commit('SET_LOADING_STATE', false)
      router.push({ name: ROUTE_NAMES.THANK_YOU_QUESTIONAIRE })
    }
  },
  appendToQuestionaireObject({ commit }, field) {
    commit('APPEND_TO_QUESTIONAIRE_OBJECT', field)
  },
}
const state = {
  questionaireInterestObject: {},
  technologies: [],
  technologiesPraxis: [],
  loading: false,
  formResults: {
    profession: '',
    data: {},
  },
}
const getters = {
  formResults: state => JSON.parse(JSON.stringify(state.formResults)),
}
const mutations = {
  SET_TECHNOLOGIES(state, technologies) {
    state.technologies = technologies
  },
  SET_TECHNOLOGIES_PRAXIS(state, technologiesPraxis) {
    state.technologiesPraxis = technologiesPraxis
  },
  SET_LOADING_STATE(state, newLoadingState) {
    state.loading = newLoadingState
  },
  APPEND_TO_QUESTIONAIRE_OBJECT(state, field) {
    let newQuestionaireInterestObject = Object.assign(state.questionaireInterestObject, field)
    state.questionaireInterestObject = newQuestionaireInterestObject
  },
  SET_FORM_RESULTS_PROFESSION(state, profession) {
    state.formResults.profession = profession
  },
  SET_FORM_RESULTS_DATA(state, data) {
    state.formResults.data = data
  },
}

store.registerModule('QUESTIONAIRE', {
  namespaced: true,
  strict: false,
  state,
  actions,
  mutations,
  getters,
})

//helpers
function makeid(length) {
  var text = ''
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

  for (var i = 0; i < length; i++) text += possible.charAt(Math.floor(Math.random() * possible.length))

  return text
}
